<template>
  <b-modal id="bv-modal-error"
           :ok-only="true"
           @hide="onHide"
           ok-variant="plm-primary"
  >
    <template v-slot:modal-title>
      <span>{{title}}</span>
      <font-awesome-icon icon="exclamation"  class="text-danger ml-4" style="margin-bottom: 1px"/>
      <font-awesome-icon icon="exclamation"  class="text-danger " style="margin-bottom: 1px"/>
      <font-awesome-icon icon="exclamation"  class="text-danger " style="margin-bottom: 1px"/>
    </template>
    <div class="d-block text-center">
      {{message}}
    </div>
  </b-modal>

</template>

<script>
export default {
  name: "ErrorDialog",
  async beforeMount() {
  },
  methods: {
    async onHide(ev){
      if(this.resolve != null){
        this.resolve(null);
        this.resolve = null;
      }
    },
    reset(){
      this.resolve = null;
    }
  },
  data: () => ({
    title:"title",
    message:"message",
    resolve: null,
  })
}
</script>
